/* eslint-disable max-len */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import {
  Button,
  TextField,
  Typography,
  Switch,
  Divider,
  Grid,
} from '@material-ui/core';
import MomentUtils from '@date-io/moment';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import { makeStyles } from '@material-ui/core/styles';
import { parcoursTypes } from '../../../../helpers/utils';
import useSemester from './useSemester';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    marginBottom: 20,
  },
}));

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused || state.isSelected ? '#deebff' : 'white',
    color: 'black',
    width: '100%',
    fontSize: '14px',
  }),
  control: (base, state) => ({
    ...base,
    minHeight: '56px',
    marginTop: '16px',
    fontSize: '16px',
    boxShadow: state.isFocused ? '0 0 0 1px #002984' : 0,
  }),
  menu: (provided) => ({ ...provided, zIndex: 98 }),
};

const NewSemester = ({
  type, semestersData, setSemestersData, companyId, semestersList, referentsList, isCompany,
}) => {
  const [form, setForm] = useState({
    semester: '',
    referents: [],
    needFormer: false,
    presentialGroups: '',
    presentialHours: '',
    elearningHours: '',
    beginDate: null,
    endDate: null,
    catchUpDate: null,
  });
  const [needFormer, setNeedFormer] = useState(false);
  const classes = useStyles();
  const { addSemester } = useSemester(companyId, semestersData, setSemestersData, type);

  useEffect(() => {
    if (semestersList !== undefined && semestersList.length > 0) {
      const tmpBegin = new Date(semestersList[0].begin);
      const tmpEnd = new Date(semestersList[0].end);
      tmpBegin.setHours(15);
      tmpEnd.setHours(15);
      setForm({
        ...form,
        semester: semestersList[0],
        beginDate: tmpBegin,
        endDate: tmpEnd,
      });
    }
  }, [type]);

  useEffect(() => {
    setForm({
      ...form,
      beginDate: form.semester.begin,
      endDate: form.semester.end,
    });
  }, [form.semester]);

  useEffect(() => {
    if (needFormer === false) {
      setForm({
        ...form,
        presentialHours: '',
        presentialGroups: '',
      });
    }
  }, [needFormer]);

  return (
    <div className={classes.root}>
      { parcoursTypes.includes(type) && semestersData.length >= 1
        ? null
        : (
          <>
            <Typography
              component="h6"
              variant="h6"
            >
              {parcoursTypes.includes(type) || isCompany ? 'Parcours' : 'Semestre'}
            </Typography>
            <Grid container spacing={2}>
              {!parcoursTypes.includes(type)
                ? (
                  <>
                    <Grid item md={4}>
                      <Select
                        value={form.semester}
                        styles={customStyles}
                        options={semestersList}
                        placeholder={parcoursTypes.includes(type) || isCompany ? 'Parcours' : 'Semestre'}
                        onChange={(e) => { setForm({ ...form, semester: e }); }}
                      />
                    </Grid>
                    <Grid item md={1} />
                  </>
                )
                : null}
              <Grid
                item
                md={5}
                onClick={() => setNeedFormer(!needFormer)}
                style={{
                  display: 'flex', flexDirection: 'row', alignItems: 'center', paddingTop: '15px',
                }}
              >
                <Typography>
                  Avez-vous besoin d&apos;un formateur EW ?
                </Typography>
                <br />
                <br />
                <Switch
                  checked={needFormer}
                  onChange={() => setNeedFormer(!needFormer)}
                  name="checkRecurent"
                  color="primary"
                />
                {needFormer
                  ? <Typography>oui</Typography>
                  : <Typography>non</Typography>}
              </Grid>
            </Grid>
            {
      needFormer
        ? (
          <Grid container spacing={2} style={{ paddingBottom: '10px' }}>
            <Grid item md={4}>
              <TextField
                label="Nombre de groupes en presentiel"
                variant="outlined"
                margin="normal"
                value={form.presentialGroups}
                onChange={(e) => setForm({ ...form, presentialGroups: e.target.value })}
                fullWidth
              />
            </Grid>
            <Grid item md={4}>
              <TextField
                label={"Nombre d'heures de presentiel"}
                variant="outlined"
                // error={handleNumber(form.presentialHours)}
                margin="normal"
                value={form.presentialHours}
                onChange={(e) => setForm({ ...form, presentialHours: e.target.value })}
                fullWidth
              />
            </Grid>
          </Grid>
        ) : null
    }
            <Grid container spacing={2}>
              <Grid item md={4}>
                <TextField
                  label={"Nombre d'heures d'e-learning"}
                  variant="outlined"
                  margin="normal"
                  // error={handleNumber(form.elearningHours)}
                  value={form.elearningHours}
                  onChange={(e) => setForm({ ...form, elearningHours: e.target.value })}
                  fullWidth
                />
              </Grid>
              <Grid item md={1} />
              <Grid item md={7}>
                <Select
                  value={form.referents}
                  styles={customStyles}
                  isMulti
                  options={referentsList}
                  getOptionLabel={(option) => `${option.name} ${option.firstname}`}
                  placeholder="Réferent(s).."
                  noOptionsMessage={() => 'Ajoutez des référents dans les données pédagogiques'}
                  onChange={(e) => { setForm({ ...form, referents: e }); }}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2} style={{ display: 'flex', alignItems: 'center' }}>
              <Grid item md={4}>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                  <KeyboardDatePicker
                    required
                    autoOk
                    inputMode="none"
                    fullWidth
                    // error={errors.beginDate}
                    format="DD/MM/YYYY"
                    onChange={(e) => {
                      if (e !== null) {
                        setForm({ ...form, beginDate: e._d });
                      }
                    }}
                    value={form.beginDate}
                    helperText={parcoursTypes.includes(type) || isCompany ? 'Date de début du parcours' : 'Date du début du semestre'}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item md={4}>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                  <KeyboardDatePicker
                    required
                    inputMode="none"
                    autoOk
                    format="DD/MM/YYYY"
                    fullWidth
                    onChange={(e) => {
                      if (e !== null) {
                        setForm({ ...form, endDate: e._d });
                      }
                    }}
                    value={form.endDate}
                    helperText={parcoursTypes.includes(type) || isCompany ? 'Date de fin du parcours' : 'Date du fin du semestre'}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item md={4}>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                  <KeyboardDatePicker
                    required
                    inputMode="none"
                    autoOk
                    format="DD/MM/YYYY"
                    fullWidth
                    onChange={(e) => {
                      if (e !== null) {
                        setForm({ ...form, catchUpDate: e._d });
                      }
                    }}
                    value={form.catchUpDate}
                    helperText="Date de fin de rattrapage"
                  />
                </MuiPickersUtilsProvider>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item md={9} />
              <Grid item md={3}>
                <Button
                  onClick={() => addSemester(form, needFormer)}
                  style={{ marginTop: '1.5em', padding: '1em 0 1em 0' }}
                  variant="contained"
                  color="primary"
                  fullWidth
                >
                  + Ajouter
                </Button>
              </Grid>
            </Grid>
            <Divider style={{ margin: '1.5em' }} />
          </>
        )}
    </div>
  );
};

NewSemester.propTypes = {
  type: PropTypes.string.isRequired,
  semestersData: PropTypes.array.isRequired,
  companyId: PropTypes.string.isRequired,
  setSemestersData: PropTypes.func.isRequired,
  isCompany: PropTypes.bool.isRequired,
  semestersList: PropTypes.array.isRequired,
  referentsList: PropTypes.array.isRequired,
};

export default NewSemester;
